module.exports = __webpack_public_path__ + "img/thumbnails-20-speak-number-guess.6c36dcab.png";